module.exports = __webpack_public_path__ + "static/media/1022823.04dae2ec.jpg";